var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-dark",attrs:{"id":"app"}},[(_vm.firstVisit)?_c('LandingPage',{on:{"go-to-home":function($event){return _vm.goToHome()}}}):_c('Page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }